export default Object.freeze({
  GRID_ITEM: 'grid-item',
  TREE_ITEM: 'tree-item',
  CATALOGUE_IMAGE: 'catalogue-image',
  CATALOGUE_VIDEO: 'catalogue-video'
});